import { Injectable } from '@angular/core';
import { BcmSettingsFacade } from '@bcmServices/settings/bcm-settings-facade';
import { BcmSettingsSectionName } from '@shared/models/bcm-settings';
import { environment } from '@env/environment';
import { BcmService } from '@modules/bcm/bcm.service';
import {
    isOrderManagementV2Enabled,
    OrderManagementRolloutEnvironmentConfig,
    OrderManagementRolloutFlag,
    OrderManagementRolloutResolution,
    OrderManagementRolloutResolutionContext,
    OrderManagementRolloutTenantSettings,
    parseOrderManagementRolloutEnvironmentConfig,
    resolveOrderManagementRolloutFlag,
    shouldUseLegacyOrderManagementFlow,
} from '@shared/helpers/order-management-rollout-model.util';

@Injectable({ providedIn: 'root' })
export class OrderManagementRolloutService {
    readonly flags = OrderManagementRolloutFlag;

    constructor(
        private readonly settingsFacade: BcmSettingsFacade,
        private readonly bcmService: BcmService,
    ) {}

    isV2Enabled(flag: OrderManagementRolloutFlag): boolean {
        return isOrderManagementV2Enabled(
            flag,
            this.getTenantSettings(),
            this.getEnvironmentConfig(),
            this.getResolutionContext(),
        );
    }

    shouldUseLegacyFlow(flag: OrderManagementRolloutFlag): boolean {
        return shouldUseLegacyOrderManagementFlow(
            flag,
            this.getTenantSettings(),
            this.getEnvironmentConfig(),
            this.getResolutionContext(),
        );
    }

    resolveFlag(flag: OrderManagementRolloutFlag): OrderManagementRolloutResolution {
        return resolveOrderManagementRolloutFlag(
            flag,
            this.getTenantSettings(),
            this.getEnvironmentConfig(),
            this.getResolutionContext(),
        );
    }

    private getTenantSettings(): OrderManagementRolloutTenantSettings {
        return this.settingsFacade.settings()?.[BcmSettingsSectionName.OrderManagementRollout] || {};
    }

    private getEnvironmentConfig(): OrderManagementRolloutEnvironmentConfig {
        return parseOrderManagementRolloutEnvironmentConfig(environment.orderManagementRollout);
    }

    private getResolutionContext(): OrderManagementRolloutResolutionContext {
        return {
            activeModulePermissionNames: this.bcmService.tenant?.permissions || [],
        };
    }
}
